import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox';
import styled from "styled-components"
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app
import { chunk } from 'lodash';

class Gallery extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false,
    };
  }

  render() {
    const { photoIndex, isOpen } = this.state;
    const images = this.props.images;
    return (
      <GalleryContainer>

        {chunk(images, 3).map((chunkedImages, chunkedIndex) => {
          return <ThumbnailRow key={chunkedIndex}>
            {chunkedImages.map((url, index) => {
              const originalIndex = (chunkedIndex * 3) + index;
              return <ImageThumbnail style={{ backgroundImage: `url(${url})` }} key={originalIndex} onClick={() => {
                this.setState({ isOpen: true, photoIndex: originalIndex })
              }}></ImageThumbnail>
            })}
          </ThumbnailRow>
        })}

        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length,
              })
            }
          />
        )}
      </GalleryContainer>
    );
  }
}

export default Gallery

const GalleryContainer = styled.div`
  margin: 30px 0;
`;

const ThumbnailRow = styled.div`
  display: flex;
  margin: 0 -5px;
  @media (max-width: 960px) {
    display: block;
    margin: 0 20px;
  }
`;

const ImageThumbnail = styled.div`
  overflow: hidden;
  width: 303px;
  margin: 5px;
  height: 200px;
  cursor: pointer;
  background-size: cover;

  @media (max-width: 960px) {
    width: 100%;
    height: 500px;
    margin: 15px 0;
  }

  @media (max-width: 800px) {
    height: 400px;
  }
  
  @media (max-width: 650px) {
    height: 300px;
  }
  
  @media (max-width: 500px) {
    height: 260px;
  }
  
  @media (max-width: 450px) {
    height: 230px;
  }
  
  @media (max-width: 350px) {
    height: 200px;
  }
`;